import { render } from "./FinancialHealthResult.vue?vue&type=template&id=0640c104&scoped=true"
import script from "./FinancialHealthResult.vue?vue&type=script&lang=js"
export * from "./FinancialHealthResult.vue?vue&type=script&lang=js"

import "./FinancialHealthResult.vue?vue&type=style&index=0&id=0640c104&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0640c104"]])

export default __exports__